module.exports = __webpack_public_path__ + "img/not_good.6751ffbd.svg";